import React, { memo, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Commons/Loader/Loader";
import style from "./WhatNewPopup.module.css";
import { clearCacheData } from "../../Utils/misc";

function WhatNewPopup(props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  //update func
  const updateFunc = () => {
    setIsLoading(true);
    try {
      clearCacheData();
      //hard reload
      toast.success("Web Application Updated Successfully!");
      toast.success("You Have Latest Web!");
      props.close(false);
      setTimeout(() => {
        //session clear
        sessionStorage.clear();
        navigate("/login");
        window.location.reload(true);
      }, [2000]);

      
    } catch (err) {
      props.close(false);
     
    }
    setIsLoading(false);
  };

  //data list organize
  const [listData, setListData] = useState([]);

  const organizeDataFunc = () => {
    setIsLoading(true);
  try{
    if (props.data && props.data.Feature) {
      if (props.data.Feature.includes("\n")) {
        setListData(props.data.Feature.split("\n"));
      } else {
        setListData([props.data.Feature]);
      }
    } else {
      props.close(false);
     
    }
  } catch (err) {
    props.close(false);
   
  }
  setIsLoading(false);
  };
  useEffect(() => {
    organizeDataFunc();
  }, []);

  return (
    <>
      <div className="main_popup">
        <div className={`main_popup_card ${style.card}`}>
          <h1>What's New</h1>

          <div className={style.WhatNewSection}>
            {listData && listData.map((elem, ind) => {
              return (
                <div className={style.WhatNewSec}>
                  <p className={style.WhatNewSec_Details}>{elem}</p>
                </div>
              );
            })}
          </div>

          <button className={"primary_Btn"} onClick={() => updateFunc()}>
            Update
          </button>
        </div>
      </div>

      {isLoading && (
        <div className="main_popup">
          <div>
            <Loader />

    
          </div>
        </div>
      )}
    </>
  );
}

export default memo(WhatNewPopup);
